import { IBuilderInfoKind } from './types';

export const builderInfoWidthLookup: Record<IBuilderInfoKind, number> = {
  namedMeasure: 600,
  namedFilter: 600,
  namedBucketDef: 400,
  basicBucketDef: 400,
  virtualEvent: 600,
  report: 720,
  namedCohort: 720,
};
